module.exports = __webpack_public_path__ + "static/harp-eba09b6a457792c52fc610b5f9f974b3.mp3";